var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Adjure",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1);}\r\n\t.st1{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1",
    gradientUnits: "userSpaceOnUse",
    x1: -265.6429,
    y1: 426.8571,
    x2: -265.6429,
    y2: 425.8571,
    gradientTransform: "matrix(70 0 0 -70 18630 29880)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#965DE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6558EE"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,0h46c6.6,0,12,5.4,12,12v46c0,6.6-5.4,12-12,12H12C5.4,70,0,64.6,0,58V12C0,5.4,5.4,0,12,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.8,55.3V41.1c0.1-0.6,0.4-1,0.9-1.3c0.6-0.2,1.3-0.2,1.9,0.1l12.6,7c0.9,0.5,2,0.2,2.6-0.6 c0.2-0.4,0.3-0.9,0.2-1.4c-0.1-0.5-0.4-0.9-0.9-1.1l-12.7-7c-1.8-0.9-3.9-0.9-5.6,0c-1.5,0.9-2.5,2.4-2.7,4.2v14.4 c0,1,0.9,1.8,2,1.8C36,57.1,36.8,56.3,36.8,55.3L36.8,55.3z M29.8,54.3V34.4c0.2-1.6,1.1-2.9,2.5-3.7c2.2-1.3,5.1,0.1,5.1,0.1 l10.7,5.9c0.1,0,0.1,0.1,0.2,0.1c1.9,1,3.8,2,5.7,3c0.2,0.1,0.5,0.3,1,0.4c0.4,0.1,0.8,0.2,1.1,0.1c0,0,0,0,0,0 c0.5,0,0.7-0.5,0.8-0.7c0.3-0.5,0.4-1,0.4-1.1c0.7-5.7-0.6-9.9-0.6-9.9c-0.6-1.9-1.9-5.7-5.4-9.4c-6-6.2-13.5-6.8-14.8-6.9 c-1.5-0.1-9.4-0.5-16.2,5.3c-1.4,1.2-6.1,5.5-7.6,13c-0.2,1.2-1.6,9.1,3.2,16.6c0,0,4.2,6.4,11.3,8.8c0.1,0,0.3,0.1,0.3,0.1 c0.2,0,0.9,0.2,1.6-0.3C29.7,55.2,29.8,54.5,29.8,54.3z M51.4,34.1c-0.1-1.5-0.3-4-1.8-6.8c-2.3-4.3-5.9-6.4-7.5-7.1 c-4.3-2-10-2.3-15.1,0.4c-5.6,3.1-8.9,9.4-8.4,15.8c0.6,7.5,6.5,11.8,7.3,12.5c0.1,1.2,0,2.3,0.1,3.5c-1.7-0.8-4.8-3-7.3-6.4 C13.8,39.1,15.7,31.2,16,30c1.7-6.3,6.1-9.8,7.4-10.8c1.2-0.9,6.7-4.7,14.3-3.6c7,1,11.1,5.5,12.2,6.8c4.7,5.5,4.7,11.8,4.7,13.3  M23.1,41c-2.1-4-2-9.4,0.8-13.6c3.5-5.1,9.2-5.7,9.9-5.7c0.6,0,6.4-0.4,10.8,4.1c2.6,2.7,3.3,5.7,3.5,7c-3-1.7-6-3.4-9-5.1 c-1.5-0.7-3.1-1-4.7-1c-1.5,0-2.9,0.3-4.2,1.1c-2.4,1.4-4,3.8-4.3,6.6c0,3.6,0,6.8,0,10.4C25.2,43.9,24,42.7,23.1,41z M44,53.2v-3.1 l2.8,1.5c0.9,0.5,2,0.2,2.6-0.7c0.2-0.4,0.3-0.9,0.2-1.4c-0.1-0.5-0.5-0.9-0.9-1.1l-4-2.2c-1-0.5-2.1-0.5-3,0 c-0.8,0.5-1.4,1.3-1.5,2.3v4.5c0,1,0.9,1.8,2,1.8C43.2,54.9,44,54.2,44,53.2L44,53.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3808662142b0a7ffe796db25e4b30e9e.svg";
export { ForwardRef as ReactComponent };